import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { LayoutContainerComponent } from './layout-container/layout-container.component';
import { PublicLayoutComponent } from './public-layout/public-layout.component';
import { PrivateLayoutComponent } from './private-layout/private-layout.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [
    LayoutContainerComponent,
    PublicLayoutComponent,
    PrivateLayoutComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    TranslateModule,
    NgbModalModule,
  ],
  exports: [
    LayoutContainerComponent,
    PublicLayoutComponent,
    PrivateLayoutComponent,
  ],
})
export class LayoutModule {}
